define(["require", "exports", "jquery", "./context", "./notifications", "./dialogs/addToCartSuccess"], function (require, exports, $, context_1, notifications, addToCartSuccess_1) {
    "use strict";
    exports.__esModule = true;
    var instance = null;
    function markMissingAttributes(attrNames) {
        var foundMissingAttrs = false;
        if (attrNames.length) {
            var fields = $.map(attrNames, function (attrName, i) {
                return $("input[data-attribute-name=\"" + attrName.toLowerCase() + "\"]").add("input[data-attribute-name=\"" + attrName + "\"]");
            });
            var panels = $.map(fields, function (field, i) {
                var panel = field.closest('.attribute-panel');
                if (!panel.length) {
                    panel = field.prev('.attribute-panel');
                }
                return panel;
            });
            var buttons = $.map(panels, function (panel, i) { return panel.prev('.attribute-button'); });
            $(buttons).toggleClass('missing', true);
            foundMissingAttrs = buttons.reduce(function (f, button) { return f || button.length > 0; }, false);
            if (foundMissingAttrs) {
                var anchor = buttons[0].parent();
                if (anchor.length) {
                    $(window).scrollTop(anchor.offset().top - 90);
                }
            }
        }
        return foundMissingAttrs;
    }
    exports.markMissingAttributes = markMissingAttributes;
    function initFlyoutCartInteraction() {
        $('#flyout-cart .checkoutbutton').click(gotoCart);
        $('#flyout-cart').on('mouseleave', function () {
            var cart = $('#flyout-cart');
            if (cart.is(':visible')) {
                cart.slideUp("slow", function () {
                    $(this).removeClass("after-add-cart");
                });
            }
        });
    }
    function initFlyoutCartForDesktop() {
        initFlyoutCartInteraction();
        $('#topcartlink').on('mouseenter', function () {
            var cart = $('#flyout-cart');
            if (!cart.is(':visible'))
                cart.slideDown("slow");
        });
        $('.header-links-wrapper').on('mouseleave', function () {
            var cart = $('#flyout-cart');
            if (cart.is(':visible')) {
                cart.slideUp("slow", function () {
                    $(this).removeClass("after-add-cart");
                });
            }
        });
    }
    exports.initFlyoutCartForDesktop = initFlyoutCartForDesktop;
    function gotoCart(e) {
        var url = $(e.currentTarget).data('href');
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url || '/cart';
    }
    exports.gotoCart = gotoCart;
    function addSampleToCart(postUrl, e) {
        var $link = $(e.currentTarget);
        e.preventDefault();
        e.stopPropagation();
        var productLink = $link.attr('href');
        var matches = productLink.match(/^\/p\/(\d+)\//);
        var productId = matches && matches.length > 1 ? Number(matches[1]) : NaN;
        if (!isNaN(productId)) {
            var url = postUrl.replace(/\/0$/, "/" + productId);
            AjaxCart.instance().addproducttocart(url);
        }
    }
    exports.addSampleToCart = addSampleToCart;
    var AjaxCart = (function () {
        function AjaxCart(usepopupnotifications, topcartselector, topwishlistselector, flyoutcartselector, usePopupDialog) {
            this.usepopupnotifications = usepopupnotifications;
            this.topcartselector = topcartselector;
            this.topwishlistselector = topwishlistselector;
            this.flyoutcartselector = flyoutcartselector;
            this.usePopupDialog = usePopupDialog;
        }
        AjaxCart.init = function (usepopupnotifications, topcartselector, topwishlistselector, flyoutcartselector, usePopupDialog) {
            if (!instance) {
                instance = new AjaxCart(usepopupnotifications, topcartselector, topwishlistselector, flyoutcartselector, usePopupDialog);
            }
            return instance;
        };
        AjaxCart.instance = function () {
            return instance;
        };
        AjaxCart.prototype.setLoadWaiting = function (waiting) {
            notifications.displayAjaxLoading(waiting);
            this.loadWaiting = waiting;
        };
        AjaxCart.prototype.addproducttocart = function (postUrl, data, imageFile) {
            var _this = this;
            if (this.loadWaiting) {
                return;
            }
            window.fbq('track', 'AddToCart');
            this.setLoadWaiting(true);
            var formData = null;
            if (imageFile) {
                formData = new FormData();
                formData.append('imageFile', imageFile);
                $.each(data, function (name, value) {
                    formData.append(name, value);
                });
                formData.append('quantity', '0');
            }
            return $.ajax({
                cache: false,
                url: postUrl,
                data: formData || data,
                type: 'post',
                contentType: formData ? false : undefined,
                processData: formData ? false : undefined,
                success: function (data) { _this.setLoadWaiting(false); _this.successProcess(data); },
                error: function (xhr) {
                    _this.setLoadWaiting(false);
                    if (xhr.status === 0 || xhr.statusText === 'abort') {
                        return;
                    }
                    _this.ajaxFailure(xhr);
                }
            });
        };
        AjaxCart.prototype.addProductVariantsToCart = function (postUrl, data, imageFile) {
            return this.addproducttocart(postUrl, data, imageFile);
        };
        AjaxCart.prototype.addproductvarianttocart = function (postUrl, formselector) {
            this.addproducttocart(postUrl, $(formselector).serialize());
        };
        AjaxCart.prototype.successProcess = function (response) {
            if (response.updatetopcartsectionhtml) {
                $(this.topcartselector).html(response.updatetopcartsectionhtml);
            }
            if (response.updatetopwishlistsectionhtml) {
                $(this.topwishlistselector).html(response.updatetopwishlistsectionhtml);
            }
            if (response.updateflyoutcartsectionhtml) {
                $(this.flyoutcartselector).replaceWith(response.updateflyoutcartsectionhtml);
                initFlyoutCartInteraction();
            }
            if (response.message) {
                if (response.success === true) {
                    console.log('response.success === true');
                    $('.attribute-button.missing').toggleClass('missing', false);
                    if (this.usepopupnotifications) {
                        console.log('this.usepopunotification');
                        if (this.usePopupDialog || context_1["default"].isMobile()) {
                            console.log('this.usePopupDialog');
                            addToCartSuccess_1["default"]();
                        }
                        else {
                            notifications.displayPopupNotification(response.message, 'success', true, 2000);
                        }
                    }
                    else {
                        $('#flyout-cart').toggleClass("after-add-cart");
                        $('#flyout-cart').slideDown("slow");
                    }
                }
                else {
                    if (this.usepopupnotifications) {
                        var foundMissingAttrs = false;
                        if (Array.isArray(response.message)) {
                            foundMissingAttrs = markMissingAttributes(response.message);
                        }
                        if (!foundMissingAttrs) {
                            notifications.displayPopupNotification(response.message, 'error', true);
                        }
                    }
                    else {
                        notifications.displayBarNotification(response.message, 'error', 0);
                    }
                }
                return false;
            }
            if (response.redirect) {
                location.href = response.redirect;
                return true;
            }
            return false;
        };
        AjaxCart.prototype.ajaxFailure = function (xhr) {
            alert('Failed to add the product to the cart. Please refresh the page and try one more time.');
        };
        return AjaxCart;
    }());
    exports.AjaxCart = AjaxCart;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/ajaxCart.js
// module id = 28
// module chunks = 0